module.exports = __webpack_public_path__ + "img/bg.8fc6a971.png";